export const FREQUENCIES = Object.freeze([
  'never',
  'daily',
  'weekly',
  'monthly',
  'yearly',
]);

export const CALENDAR_FREQUENCIES = Object.freeze(['monthly', 'yearly']);

export const MODES = Object.freeze(['dayOfMonth', 'nthWeekday']);

export const NTH_VALUES = Object.freeze([1, 2, 3, 4, 'last']);

export const WEEKDAY_LABELS = Object.freeze([
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]);

/** Short weekday labels for compact repeat summaries (picker trigger, tables). */
export const WEEKDAY_LABELS_SHORT = Object.freeze(['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']);

/** Single-letter labels for weekly repeat-on picker (Sunday first). */
export const WEEKDAY_PICKER_LETTERS = Object.freeze(['S', 'M', 'T', 'W', 'T', 'F', 'S']);

export const FREQUENCY_OPTIONS = Object.freeze(
  FREQUENCIES.map((f) => ({
    value: f,
    label:
      {
        never: 'Never',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
      }[f] || f,
  }))
);

/** Singular/plural unit labels for "Repeat every N …" row. */
export const INTERVAL_UNIT_LABELS = Object.freeze({
  daily: ['Day', 'Days'],
  weekly: ['Week', 'Weeks'],
  monthly: ['Month', 'Months'],
  yearly: ['Year', 'Years'],
});

export const ORDINAL_LABELS = Object.freeze({
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: '4th',
  last: 'last',
});

/** Title-case ordinals for inline pattern dropdowns (e.g. Third). */
export const NTH_SELECT_LABELS = Object.freeze({
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth',
  last: 'Last',
});
